
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.598 10.148l-2.176-2.17a.49.49 0 010-.694.502.502 0 01.694 0l1.336 1.342V2.74a.49.49 0 11.98 0v5.886l1.336-1.342a.502.502 0 01.694 0 .49.49 0 010 .694l-2.176 2.17a.473.473 0 01-.344.146.46.46 0 01-.344-.146z","fill":"#C4C4C4"}}),_c('path',{attrs:{"d":"M9.987 5.412h.706A2.666 2.666 0 0113.3 8.124v2.223a2.666 2.666 0 01-2.607 2.712l-7.502-.046A2.666 2.666 0 01.584 10.3V8.077a2.666 2.666 0 012.607-2.73h.706a.49.49 0 110 .98h-.706a1.68 1.68 0 00-1.627 1.75v2.206a1.68 1.68 0 001.627 1.75l7.502.081a1.68 1.68 0 001.627-1.75V8.142a1.68 1.68 0 00-1.627-1.75h-.706a.49.49 0 110-.98z","fill":"#C4C4C4"}})])
          )
        }
      }
    